{
  "close": "Закрити",
  "notifications": "{count, plural, one {# сповіщення} other {# сповіщення}}."
}
